import config from 'config'
import React, { Fragment } from 'react'
import { Header, SubHeader } from 'shared/components/ui/Typography'
import Form from './Form'

const SignupPage = () => {
  return (
    <Fragment>
      <Header size="medium" as="h1">
        Start your {config.trialDays}-day free trial
      </Header>
      <SubHeader size="small" as="h2">
        Delight your customers with fast and personal support
      </SubHeader>

      <Form />
    </Fragment>
  )
}

export default SignupPage
